import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";
import { API_BASE_URL } from "../../config";

const Login = () => {
  const navigate = useNavigate();
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handlePhoneNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Remove all non-digit characters and limit to 10 digits only
    const cleaned = e.target.value.replace(/\D/g, "").slice(0, 10);
    setPhoneNumber(cleaned);
  };

  const handleLogin = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      // First API call to get candidateId
      const response = await fetch(
        `${API_BASE_URL}/registration/phone/${phoneNumber}`
      );
      if (!response.ok) throw new Error("Login failed");

      const data = await response.json();
      const candidateId = data.id;
      localStorage.setItem("candidateId", candidateId);

      // Second API call to get screening question ID
      const questionsResponse = await fetch(
        `${API_BASE_URL}/screening-questions/questionId/${candidateId}`
      );
      if (!questionsResponse.ok)
        throw new Error("Failed to fetch screening question ID");

      const questionData = await questionsResponse.json();
      localStorage.setItem("questionId", questionData.data.questionId);

      navigate("/listening");
    } catch (error) {
      alert("Login failed. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-red-50 to-red-200">
      <div className="w-full max-w-md bg-white rounded-lg shadow-md p-8 mx-4">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold text-gray-800">Welcome Back</h1>
          <p className="text-gray-600 mt-2">
            Please enter your phone number to enter the test
          </p>
        </div>

        <form onSubmit={handleLogin} autoComplete="off">
          <div className="mb-6">
            <label
              htmlFor="phone"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Phone Number
            </label>
            <input
              id="phone"
              type="tel"
              value={phoneNumber}
              onChange={handlePhoneNumberChange}
              placeholder="Enter your phone number"
              pattern="[0-9]{10}"
              maxLength={10}
              className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent"
              required
            />
          </div>
          <button
            type="submit"
            disabled={isLoading}
            className={`w-full py-3 px-4 text-white font-medium rounded-md ${isLoading ? "bg-red-400" : "bg-red-600 hover:bg-red-700"
              } transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2`}
          >
            {isLoading ? (
              <div className="flex justify-center items-center">
                <ThreeDots
                  height="24"
                  width="50"
                  color="#ffffff"
                  ariaLabel="loading"
                  wrapperClass="flex justify-center items-center"
                />
              </div>
            ) : (
              "Log In"
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
